(function () {
    'use strict';

    angular.module("imApp").factory("ediSourcesService", ['$ihttp', function ($ihttp) {
        let service = {
            listEdiSources: function (parms) {
                return $ihttp.post({
                    method: 978,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
